class ReportConst {
  static None = 0;
  static Select = 1;
  static SelectToSelect = 2;
  static SelectToTime = 3;
  static SelectToMonth = 4;
  static Consolidate = 5;
  static Target = 6;
  static Time3D = 7;
  static SelectToHrDuplicate = 8;
  static Attendace = 9;
  static ComplexSelectToSelect = 10;
  static SelectToDay = 11;
  static ComplexTimeToSelect = 12;
  static ComplexDownload = 13;
  static SelectToHr = 14;
  static ComplexSelect = 15;
  
  static Report = 1;
  static DashLead = 2;

  static ConsolidatedActivity = 'all-activity';

  static List = 1;
  static Table = 2;
  static PieChart = 3;
  static BarGraph = 4;
  static LineChart = 5;
  static MultiBarGraph = 6;
  static MultiLineChart = 7;
  static Funnel = 8;
  static Gauge = 9;
  static Download = 10;
}
export default ReportConst;